<template>
  <div class="steps_container">
    <progress-step
      title="Start onboarding"
      state="completed"
    />
    <progress-step
      title="Connect accounts (3 mins)"
      :state="establishState('CONNECT_ACCOUNTS')"
    />
    <progress-step
      title="Choose keywords (5 mins)"
      :state="establishState('KEYWORD_IDEAS')"
    />
    <progress-step
      title="Map keywords (5 mins)"
      :state="establishState('SITEMAP')"
    />
    <progress-step
      v-if="hasOptimizerAccessPermission && !activeWebsiteIsFreeAppsumo"
      title="Onsite Optimizer (5 mins)"
      :state="establishState('OPTIMISER')"
    />
    <progress-step
      title="Finish onboarding"
      state="outstanding"
    />
  </div>
</template>

<script>
import ProgressStep from "./ProgressStep";
import { STEPS } from '../../../modules/onboarding/onboarding'
import {mapGetters} from "vuex";

export default {
  name: "OnboardingStep",
  components: {ProgressStep},
  computed: {
    ...mapGetters('onboarding', [
      'currentStep',
    ]),
    ...mapGetters('user', [
      'hasOptimizerAccessPermission',
      'activeWebsiteIsFreeAppsumo',
    ]),
  },
  methods: {
    establishState(step) {
      const currentIndex = STEPS.indexOf(this.currentStep);
      const stepIndex = STEPS.indexOf(step);

      return stepIndex === currentIndex
        ? 'active'
        : stepIndex < currentIndex
          ? 'completed'
          : 'outstanding';

    }
  }
}
</script>

<style scoped>
.steps_container {
  position: fixed;
  width: 100vw;
  height: 16px;
  background: #FFFFFF;
  display: flex;
  margin: -30px 0 0 -15px;
  z-index: 11;
}
</style>
